export const AGE_GATE_NOTICE = 'AGE_GATE_NOTICE'
export const AGE_VERIFICATION = 'AGE_VERIFICATION'
export const CLOSE_DRAFT_CONFIRMATION = 'CLOSE_DRAFT_CONFIRMATION'
export const EMOJIS = 'EMOJIS'
export const EMOJI_VIEWER = 'EMOJI_VIEWER'
export const GALLERY_ALBUM_IMAGE = 'GALLERY_ALBUM_IMAGE'
export const GUEST_LIST = 'GUEST_LIST'
export const HIDE_FLOATING_PLAYER = 'HIDE_FLOATING_PLAYER'
export const MENU = 'MENU'
export const MISS_MFC_ANONYMOUS_CONFIRMATION = 'MISS_MFC_ANONYMOUS_CONFIRMATION'
export const QUICKBUY = 'QUICKBUY'
export const REQUIRED_CHANGE = 'REQUIRED_CHANGE'
export const RULE_VIOLATION = 'RULE_VIOLATION'
export const SIGNUP_GATE = 'SIGNUP_GATE'
export const ANNOUNCE = 'ANNOUNCE'
export const WHITEBOARD = 'WHITEBOARD'
